import { isEbayInvalidMarketplace } from '../shops';

import { EBAY } from '../../constants/channels';

export function canConnectShop({ connectedShops, userShops }) {
  return function canConnect(shopId) {
    if (!userShops.hasIn(['byId', shopId]) || connectedShops.includes(shopId)) return false;

    const channel = userShops.getIn(['byId', shopId, 'channel']);

    switch (channel) {
      case EBAY: {
        if (isEbayInvalidMarketplace(userShops.getIn(['byId', shopId, 'syncStatus']))) {
          return false;
        }

        break;
      }

      default: {
        break;
      }
    }

    return true;
  };
}
